import React, { useEffect, useState } from 'react'
import MultiSelectFilter from '../../components/MultiSelectFilter';
import ClassPerformanceChart from '../../components/ClassPerformanceChart';
import { milestones, performanceData } from '../../components/StudentDasbordData';
import MilestoneCompletion from '../../components/MilestoneCompletion';
import KeyMetrics from '../../components/KeyMetrics';
import { applicationUsageBarGraph, metrics } from '../../components/EducatorProgressbarData';
import ApplicationUsageBarGraph from "../../components/ApplicationUsageBarGraph";
import { applicationService } from '../../services/applicationService';
import Filters from '../../components/MultiSelectFilter';

export default function StudentProgressbar() {

  const [allApplicationListFilter, setAllApplicationListFilter] = useState([])
  const [allSubjectListFilter, setAllSubjectListFilter] = useState([])
  const [selectedFilters, setSelectedFilters] = useState({
    apps: [],
    subject: [],
  });
  const [selectedFiltersIds, setSelectedFiltersIds] = useState({
    apps: "",
    subject: "",
  });
  const filterConfigs = [
    { key: "apps", label: "All Applications", options: allApplicationListFilter, color: "blue" },
    { key: "subject", label: "All Subjects", options: allSubjectListFilter, color: "orange" },
  ];
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    getAllApplicationForFilter()
    getAllSubjectForFilter()
  }, [])

  async function getAllSubjectForFilter() {
    try {
      const response = await applicationService.getAllSubject()
      if (response?.success == true) {
        setAllSubjectListFilter(response?.data)
      } else {
        setAllSubjectListFilter([])
      }
    } catch (e) {
      console.error('Error fetching data:', e)
    }
  }


  async function getAllApplicationForFilter() {
    try {
      const response = await applicationService.getAllApplicationForFilter()
      if (response?.success == true) {
        setAllApplicationListFilter(response?.data)
      } else {
        setAllApplicationListFilter([])
      }
    } catch (e) {
      console.error('Error fetching data:', e)
    }
  }

  return (

    <div className="p-4">
      <div className='flex items-center justify-between  p-4'>
        <div>
          <Filters filterConfigs={filterConfigs} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} selectedFiltersIds={selectedFiltersIds} setSelectedFiltersIds={setSelectedFiltersIds} dateRangePicker='true' startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
        </div>
      </div>
      <div className="card mt-3">
        <div className="grid md:grid-cols-2 gap-6  ">
          <div className='p-4'>

            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-[#717576] ">
                Performance Trend
              </h2>
            </div>
            <ClassPerformanceChart data={performanceData} />
          </div>
          <div className='p-4'>
            <h2 className="text-lg font-semibold text-[#717576] mb-4">Key Metrics</h2>
            <KeyMetrics metrics={metrics} />
          </div>
        </div>
        <div className="grid md:grid-cols-2 gap-6  ">
          <div className='p-4'>
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-[#717576] ">
                Application Usage
              </h2>
            </div>
            <ApplicationUsageBarGraph applicationUsageBarGraph={applicationUsageBarGraph} />
          </div>
          <div className='p-4'>
            <h2 className="text-lg font-semibold text-[#717576] mb-2">Milestone Completion</h2>
            <MilestoneCompletion milestones={milestones} />
          </div>
        </div>
      </div>
    </div>
  )
}
